@if (isAuthenticating) {
  <div class="auth-container">
    <h5>Authenticating</h5>
  </div>
} @else {
  <div class="auth-container">
    <h5>An error occurred while authenticating. If the issue persists report it to the ITS Service Desk.</h5>
  </div>
}
